export default "__VITE_ASSET__B7LrmLd1__"